import { Box, Button, Paper } from '@material-ui/core'

import React from 'react'
import styled from 'styled-components'

const StyledPaperContainer = styled(Paper)`
  height: 100%;
  margin: 10px 0px 0px 0px;
  padding: 20px;
`

const StyledButtonContainer = styled.div`
  margin: 0px 5px 0px 5px;
`

const StyledButton = (props: any) => (
  <StyledButtonContainer>
    <Button {...props} />
  </StyledButtonContainer>
)

const SettingFormHandlerBar = ({
  saveHandler
}: {
  saveHandler: (...args: any) => any
}) => {
  return (
    <StyledPaperContainer>
      <Box display="flex" justifyContent="flex-end">
        <StyledButton variant="outlined" color="default" onClick={saveHandler}>
          Save
        </StyledButton>
      </Box>
    </StyledPaperContainer>
  )
}

export default SettingFormHandlerBar
